import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { HttpClient, HttpHeaders, HttpClientModule } from '@angular/common/http';
import { HttpModule } from '@angular/http';
import { ActivatedRoute, Router } from '@angular/router';
import swal from 'sweetalert2';
import { environment } from '../../../environments/environment';

import { CookieService } from 'ngx-cookie-service';


@Component({
	selector: 'app-sign-in',
	templateUrl: './sign-in.component.html',
	styleUrls: ['./sign-in.component.css']
})
export class SignInComponent implements OnInit {
	loginForm : FormGroup;
	private url = environment.url;
	cookieValue = 'default';

	constructor( private http : HttpClient, 
		private router : Router, 
		private cookieService: CookieService) 
	{ }

	ngOnInit() {
		this.loginForm = new FormGroup ({
			"username" : new FormControl(null, Validators.required),
			"password" : new FormControl(null, Validators.required),
			"keepmesignin": new FormControl(null)
		});

		if(this.checkCookie( 'uName') && this.checkCookie( 'uPass'))
		{
			this.loginForm.patchValue({
				"username": this.getCookie( 'uName'),
				"password": this.getCookie( 'uPass'),
				"keepmesignin": "checked"
			});
		}


		// If already login then rediect page to dashboard
		var myObject = localStorage.getItem('currentUser');
		var temp = JSON.parse(myObject);	

		if(localStorage.getItem('currentUser'))
		{
			if (temp["role"] === 'Admin'){
				this.router.navigate(['select/branch']);
			}
			else if(temp['role'] === 'Manager' || temp['role'] === 'Employee'){
				this.router.navigate(['select/client/' + temp['branch']]);
			}
		}


	}

	submit()
	{
		this.http.post(this.url + "/signin", this.loginForm.value)
		.subscribe(res => {
			console.log(res);
			if(res["status"])
			{
				localStorage.setItem('currentUser', JSON.stringify({ token: res["token"], role : res["role"], branch:res["branch"], username :res["name"] }));
				localStorage.setItem('user_token', JSON.stringify(res["token"]))
				if (res['role'] === 'Admin'){
					this.router.navigate(['select/branch']);
				}
				else if(res['role'] === 'Manager' || res['role'] === 'Employee'){
					this.router.navigate(['select/client/' + res['branch']]);
				}

				if(this.loginForm.get("keepmesignin").value)
				{
					this.deleteCookie( 'uName');
					this.deleteCookie( 'uPass');
					this.setCookie( 'uName', this.loginForm.get("username").value );
					this.setCookie( 'uPass', this.loginForm.get("password").value );
				}
				else
				{
					this.deleteCookie( 'uName');
					this.deleteCookie( 'uPass');
				}
				 
				 //this.setCookie( 'uRole', res['role'] );
				
			}
			else{
				if (res["message"] === "Incorrect Credentials"){
					swal(
						'Incorrect Login Credentials',
						'Please Enter Valid Username and Password',
						'error'
					);
				}
				else if (res["message"] === "Please Contact Admin for your Login Permission"){
					swal(
						'Ohho!',
						'Please Contact Admin for your Login Permission',
						'warning'
					);
				}
			}	
		},
		error =>{
				swal(
					'Incorrect Login Credentials',
					'Please Enter Valid Username and Password',
					'error'
				);
			}
		);
	}

	setCookie(key: string,value: any)
	{
    	return this.cookieService.set(key,value);
 	}
	getCookie(key: string)
	{
    	return this.cookieService.get(key);
 	}
 	checkCookie(key: string)
 	{
    	return this.cookieService.check(key);
  	}

  //get All Cookie
  //Syntax - getAll(): {};
  	getAllCookie()
  	{
    	return this.cookieService.getAll();
  	}

  //delete cookie
  //Syntax - delete( name: string, path?: string, domain?: string ): void;
  	deleteCookie(key: string)
  	{
    	return this.cookieService.delete(key);
  	}

  //delete All cookie
  //Syntax - deleteAll( path?: string, domain?: string ): void;
  	deleteAllCookie()
  	{
    	return this.cookieService.deleteAll();
  	}
}



// WEBPACK FOOTER //
// /Users/meghneel/work/baba_frontend/src/app/auth/sign-in/sign-in.component.ts